import { ReactNode } from "react";
import { PERMISSION } from "src/types";
import { isDisabled, isEnabled, isHidden, isVisible } from "src/utils/permission.utils";

interface Props {
  type?: "every" | "some";
  permission: PERMISSION | PERMISSION[];
  children: ReactNode;
}

const defaultProps: Partial<Props> = { type: "every" };

function checkPermission(props: Props, permissionFn: (permission: PERMISSION) => boolean) {
  const { permission, children, type } = props;

  if (Array.isArray(permission)) {
    if (type === "every") {
      const allValid = permission.every((item) => permissionFn(item));
      if (allValid) return <>{children}</>;
    } else if (type === "some") {
      const allValid = permission.some((item) => permissionFn(item));
      if (allValid) return <>{children}</>;
    }
    return null;
  } else {
    if (permissionFn(permission)) return <>{children}</>;
    return null;
  }
}

export function IsEnabled(props: Props) {
  const mergedProps = { ...defaultProps, ...props };
  return checkPermission(mergedProps, isEnabled);
}

export function IsDisabled(props: Props) {
  const mergedProps = { ...defaultProps, ...props };
  return checkPermission(mergedProps, isDisabled);
}

export function IsHidden(props: Props) {
  const mergedProps = { ...defaultProps, ...props };
  return checkPermission(mergedProps, isHidden);
}

export function IsVisible(props: Props) {
  const mergedProps = { ...defaultProps, ...props };
  return checkPermission(mergedProps, isVisible);
}
